import request from 'yeself-common/utils/RequestUtils';

import EnvironmentConfiguration from 'yeself-client-common/EnvironmentConfiguration';

export const fetchAccountsService = (groupName) =>
    request.get(
        `${EnvironmentConfiguration.API_IDENTITY_SLUG}/manage/applications/${groupName}/accountList`
    );

export const fetchAccountSettingsService = (accountId) =>
    request.get(
        `${EnvironmentConfiguration.API_IDENTITY_SLUG}/manage/applications/accounts/${accountId}`
    );

export const updateAccountSettingsService = (accountId, settings) =>
    request.put(
        `${EnvironmentConfiguration.API_IDENTITY_SLUG}/manage/applications/accounts/${accountId}`,
        settings,
        {
            header: { 'Content-Type': 'application/json' },
        }
    );

export const registerUserService = (payload) =>
    request.post(`${EnvironmentConfiguration.API_IDENTITY_SLUG}/manage/applications/accounts`, payload, {
        header: { 'Content-Type': 'application/json' },
    });
